import styled from "@emotion/styled";
import { css } from "@emotion/react";
const ellipsifyCss = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const clampCss = (props) => css`
  display: -webkit-box;
  -webkit-line-clamp: ${props.lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
export const EllipsifiedRoot = styled.div`
  ${(props) => {
  var _a;
  return ((_a = props.lines) != null ? _a : 1 > 1) ? clampCss(props) : ellipsifyCss;
}};
`;
